import React, { useState } from "react";
import { Tooltip, Button } from "antd";
import { WhatsAppOutlined, FilePdfOutlined } from "@ant-design/icons";
import { downloadPdf } from "../../lib/functions";
import { useShareDocument } from "../../hooks/useShareDocument";

// Compact WhatsApp-share + download-PDF icon pair for record/report table Action
// columns. `url` is the /print/<type>/<id> path, `fileName` is what the
// downloaded file is saved as / referenced as in the shared PDF's storage name.
const VoucherPdfActions = ({ url, fileName, disabled = false, disabledTitle }) => {
  const { loading, handleWhatsAppShare } = useShareDocument();
  const [pdfLoading, setPdfLoading] = useState(false);

  const onDownload = async (e) => {
    e.stopPropagation();
    if (pdfLoading || disabled) return;
    try {
      setPdfLoading(true);
      await downloadPdf(url, fileName);
    } catch (err) {
      console.error(err);
    } finally {
      setPdfLoading(false);
    }
  };

  const onWhatsApp = (e) => {
    e.stopPropagation();
    if (disabled) return;
    handleWhatsAppShare({ url, fileName, text: fileName });
  };

  return (
    <>
      <Tooltip title={disabled ? disabledTitle : "Share on WhatsApp"}>
        <Button
          type="link"
          icon={<WhatsAppOutlined style={{ color: disabled ? undefined : "#25D366" }} />}
          loading={loading}
          disabled={disabled}
          onClick={onWhatsApp}
        />
      </Tooltip>
      <Tooltip title={disabled ? disabledTitle : "Download PDF"}>
        <Button
          type="link"
          icon={<FilePdfOutlined />}
          loading={pdfLoading}
          disabled={disabled}
          onClick={onDownload}
        />
      </Tooltip>
    </>
  );
};

export default VoucherPdfActions;
